<div class="celebrities-container">
  <div class="header">
    <h2>Gestion des Célébrités</h2>
    <div class="actions">
      <input type="text" [(ngModel)]="searchTerm" placeholder="Rechercher..." class="search-input"
        (input)="filterCelebrities()">
      <select [(ngModel)]="statusFilter" (change)="filterCelebrities()">
        <option value="">Tous les statuts</option>
        <option value="active">Actif</option>
        <option value="inactive">Inactif</option>
        <!-- <option value="pending">En attente</option> -->
      </select>
      <button class="add-btn" (click)="addCelebrity()" style="background-color: #3b82f6;">
        <i class="fas fa-plus"></i>
        Ajouter une célébrité
      </button>
    </div>
  </div>

  <div class="table-container">
    <div *ngIf="loading" class="spinner-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Chargement...</span>
      </div>
    </div>

    <ng-container *ngIf="!loading">
      <table class="celebrities-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Email</th>
            <th>Catégorie</th>
            <th>Domaine</th>
            <th>Vidéos</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="loading">
            <tr>
              <td colspan="8" class="text-center">Chargement en cours...</td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!loading && error">
            <tr>
              <td colspan="8" class="error">{{ error }}</td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!loading && !error && filteredCelebrities.length > 0">
            <tr *ngFor="let celebrity of filteredCelebrities">
              <td>
                <div class="celebrity-info">
                  <img [src]="celebrity.profile_picture || 'assets/images/avatar.jpeg'" alt="Avatar">
                  <span>{{ celebrity.prenom }} {{ celebrity.name }}
                    @if(celebrity.official === '1') {
                    <img src="assets/images/icon/verified.png" style="width: 17px;height: 17px;" alt="verified">
                    }
                  </span>
                </div>
              </td>
              <td>{{ celebrity.email }}</td>
              <td>{{ celebrity?.category?.name }}</td>
              <td>{{ celebrity.domain?.name }}</td>
              <td>{{ celebrity.videos_count }}</td>
              <td>
                <span class="status" [class]="celebrity.status">
                  {{ celebrity.status }}
                </span>
              </td>
              <td class="actions">
                <div class="action-buttons">
                  <button *ngIf="hasAnyPermission(['view_celebrities'])" class="view-btn"
                    [routerLink]="['/admin/celebrities', celebrity.id]" title="Voir">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button *ngIf="hasAnyPermission(['edit_celebrities'])" class="edit-btn"
                    (click)="editCelebrity(celebrity)" title="Modifier">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button *ngIf="hasAnyPermission(['delete_celebrities'])" class="delete-btn"
                    (click)="deleteCelebrity(celebrity.id)" title="Supprimer">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!loading && !error && filteredCelebrities.length === 0">
            <tr>
              <td colspan="8" class="text-center">Aucune célébrité trouvée.</td>
            </tr>
          </ng-container>
        </tbody>

      </table>
    </ng-container>
  </div>

  <div class="pagination">
    <button (click)="previousPage()" [disabled]="currentPage === 1 || loading">
      Précédent
    </button>
    <span>Page {{currentPage}} sur {{totalPages}}</span>
    <button (click)="nextPage()" [disabled]="currentPage >= totalPages || loading">
      Suivant
    </button>
  </div>
</div>